// 公共API存放，例：session，登出；
import ajax from '@/utils/ajax';

const header = '/web';
export const reqUserInfo = () => ajax(`${header}/v1/user/info`); // 获取用户信息
export const reqLoginOut = () => ajax('/sso/logout', {}, 'POST'); // 登出

export const reqUserList = (unionid, distributorId) => {
  if (distributorId) {
    return ajax(`applets/v1/distribution/applets-user/list/${unionid}?distributorId=${distributorId}`);
  }
  return ajax(`applets/v1/distribution/applets-user/list/${unionid}`);
};


// 通过讲义id集合获取电子讲义信息
export const reqlectureList = (id) => ajax(`${header}/v1/lecture/list?lectureIdList=${id}`); // 获取用户信息

// 通过idList列表获取学长学姐详情
export const reqSeniorIds = (id) => ajax(`${header}/v1/senior/getByIds`,id,'POST'); // 获取用户信息
